import script from "./ShareholderIdentificationTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareholderIdentificationTab.vue?vue&type=script&setup=true&lang=ts"

import "./ShareholderIdentificationTab.vue?vue&type=style&index=0&id=111864c1&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-111864c1"]])

export default __exports__